import { Navigate } from "react-router";

/** Legacy URL: reindirizza al Control Hub e apre il pannello Ask Eve */
export const FreightForwarderAskEvePage = () => (
    <Navigate to="/freight-forwarder/control-hub" replace state={{ openAskEve: true }} />
);
